(function () {
'use strict';

angular
  .module('hyresgastApp')
  .controller('ShowNegotiationBlogCtrl', ShowNegotiationBlogCtrl);

function ShowNegotiationBlogCtrl($scope, $routeParams, ObjectTypes) {
  var vm = this;
  vm.objectId = $routeParams.id;
  vm.objectType = ObjectTypes.NEGOTIATION.code;

  $scope.$watch('vm.count', newValue => {
    if (newValue) {
      let twitsTab = $scope.$parent.vm.tablist.find(x => x.id === 'twits');
      if (twitsTab) {
        twitsTab.number = newValue;
      }
    }
  });
}
})();